import { render, staticRenderFns } from "./FormRoleDropdown.vue?vue&type=template&id=5dc4c096"
import script from "./FormRoleDropdown.vue?vue&type=script&lang=js"
export * from "./FormRoleDropdown.vue?vue&type=script&lang=js"
import style0 from "./FormRoleDropdown.vue?vue&type=style&index=0&id=5dc4c096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports